<template>
    <div class="py-16">
        <v-container>
            <v-card class="pa-5">
                <h1>Log in</h1>
                <v-row>
                    <v-col :cols="$vuetify.breakpoint.mobile ? 12 : 6">
                        <v-text-field
                            label="Email"
                            v-model="email"
                            :rules="[emailRule]"
                            required
                        ></v-text-field>
                        <v-text-field
                            label="Password"
                            v-model="password"
                            :type="passwordVisible ? 'text' : 'password'"
                            :append-icon="passwordVisible ? 'mdi-eye' : 'mdi-eye-off'"
                            @click:append="togglePasswordVisibility"
                            :rules="[passwordRule]"
                            required
                        ></v-text-field>
                        
                        <v-btn 
                            large 
                            class="primary text-capitalize py-5"  
                            @click="login" 
                            :disabled="loading"
                        >
                            <template v-if="loading">
                                <v-progress-circular indeterminate size="24"></v-progress-circular>
                            </template>
                            <template v-else>
                                Login
                            </template>
                        </v-btn>

                        <p class="py-5">
                            Don't have an account?
                            <b>
                                <router-link 
                                    v-for="(item, index) in details" 
                                    :key="index" 
                                    :to="item.routeName" 
                                    class="text-decoration-none"
                                >
                                    {{ item.name }}
                                </router-link>
                            </b>
                        </p>
                    </v-col>

                    <v-col :cols="$vuetify.breakpoint.mobile ? 12 : 6">
                        <v-img
                            height="400"
                            class="rounded-lg"
                            :src="image"
                            alt="working place"
                        ></v-img>
                    </v-col>
                </v-row>
                <v-alert v-if="errorMessage" type="error">{{ errorMessage }}</v-alert>
            </v-card>
        </v-container>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    name: 'LoginView',
    data() {
        return {
            details: [
                { name: 'Sign Up', routeName: '/register' },
            ],
            image: require('@/assets/garage.jpg'),
            email: '',
            password: '',
            passwordVisible: false,
            errorMessage: '',
            loading: false,
        };
    },
    computed: {
        emailRule() {
            return (value) => {
                const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                return emailPattern.test(value) || 'Invalid email';
            };
        },
        passwordRule() {
            return (value) => !!value || 'Password is required';
        },
    },
    methods: {
        togglePasswordVisibility() {
            this.passwordVisible = !this.passwordVisible;
        },
        async login() {
            if (this.email && this.password) {
                this.errorMessage = '';
                this.loading = true; 
                try {
                    const response = await axios.post('http://localhost:8000/login', {
                        email: this.email,
                        password: this.password,
                    });
                    console.log('Login successful:', response.data);
                    localStorage.setItem('token', response.data.token); 
                    this.email = ''; 
                    this.password = ''; 
                    this.$router.push('/customers'); 
                } catch (error) {
                    this.errorMessage = error.response?.data?.message || 'Login failed. Please try again.';
                } finally {
                    this.loading = false; 
                }
            } else {
                this.errorMessage = 'Please fill in all fields.';
            }
        },
    },
};
</script>

<style lang="scss" scoped>

</style>
